import type * as React from "react";

export type TagProps = React.HTMLAttributes<HTMLSpanElement> & { onRemove?: () => void };

/** Small removable tag/chip for filters and metadata. */
export function Tag({ onRemove, className = "", children, ...props }: TagProps) {
  return (
    <span className={["pr-tag", className].filter(Boolean).join(" ")} {...props}>
      {children}
      {onRemove && (
        <button
          type="button"
          className="pr-tag__x"
          aria-label="Remove"
          onClick={onRemove}
          style={{ background: "none", border: 0, padding: 0, color: "inherit" }}
        >
          ×
        </button>
      )}
    </span>
  );
}
